module.exports = __webpack_public_path__ + "bradavice_5_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_5_before_tn.jpg
// module id = 1406
// module chunks = 0